"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDemographicDetails = exports.DEMOGRAPHICS_BY_COUNTRY = void 0;
var AU_1 = require("./questions/AU");
var CA_1 = require("./questions/CA");
var GB_1 = require("./questions/GB");
var NZ_1 = require("./questions/NZ");
var US_1 = require("./questions/US");
var types_1 = require("./types");
var DEMOGRAPHICS_BY_COUNTRY = function (languages, countryISO, t, settings) {
    var questions = [];
    switch (countryISO) {
        case types_1.SUPPORTED_COUNTRY_ISO.CA:
            return __spreadArray(__spreadArray([], questions, true), (0, CA_1.CANADA_DEMOGRAPHICS)(t, languages, settings), true);
        case types_1.SUPPORTED_COUNTRY_ISO.US:
            return __spreadArray(__spreadArray([], questions, true), (0, US_1.USA_DEMOGRAPHICS)(t, languages, settings), true);
        case types_1.SUPPORTED_COUNTRY_ISO.AU:
            return __spreadArray(__spreadArray([], questions, true), (0, AU_1.AUSTRALIA_DEMOGRAPHICS)(t, languages, settings), true);
        case types_1.SUPPORTED_COUNTRY_ISO.NZ:
            return __spreadArray(__spreadArray([], questions, true), (0, NZ_1.NZ_DEMOGRAPHICS)(t, languages, settings), true);
        case types_1.SUPPORTED_COUNTRY_ISO.GB:
            return __spreadArray(__spreadArray([], questions, true), (0, GB_1.UK_DEMOGRAPHICS)(t, languages, settings), true);
        default:
            return questions;
    }
};
exports.DEMOGRAPHICS_BY_COUNTRY = DEMOGRAPHICS_BY_COUNTRY;
function getDemographicDetails(languages, value, countryISO, t, settings) {
    return ((0, exports.DEMOGRAPHICS_BY_COUNTRY)(languages, countryISO, t, settings).find(function (q) { return q.value === value; }) || null);
}
exports.getDemographicDetails = getDemographicDetails;
//# sourceMappingURL=index.js.map